(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
const fetch = require('cross-fetch');
$(document).ready(function () {
    setTimeout(function(){
        controlTicketFilter();
        $('.vue-select').formSelect();
        $('#popup-frame').modal();


        $('.s-training-program-wrap .s-training-program-item').first().addClass('active');
        $('.s-training-filter-ai__tab-result_public').find('.buy-btn').on('click', function () {
            if (!$('.location-select .vue-select').val()) {
                $(this).closest('.s-training-filter-ai__tab-result').find('.location-select').find('input').addClass('invalid');
            }
        })

        $('.location-select .vue-select').on('change', function () {
            $('.location-select').each(function () {
                $(this).find('input').removeClass('invalid');
            })
        })

        $('.s-header-btns .green-btn_private').on('click', function (e) {
            if ($("#appTrainingFilter")) {
                e.stopImmediatePropagation();
                e.preventDefault()

                if ($(window).width() < 767) {
                    $('html, body').animate({
                        scrollTop: $("#appTrainingFilter").offset().top - 80
                    }, 500);
                } else {
                    $('html, body').animate({
                        scrollTop: $("#appTrainingFilter").offset().top - 160
                    }, 500);
                }

                $('.s-training-filter-ai__tabs-wrap').find('.s-training-filter-ai__tab').each(function () {
                    $(this).removeClass('active');
                    if ($(this).attr('data-href') == 'privateTrainingTab') {
                        $(this).addClass('active');
                    }
                })
                $('.s-training-filter-ai__content').find('.s-training-filter-ai__tab-result').each(function () {
                    $(this).removeClass('active');
                    if ($(this).attr('data-tab-id') == 'privateTrainingTab') {
                        $(this).addClass('active');
                    }
                })
            }
        })

        function controlTicketFilter() {
            $('.s-training-filter-ai__tab').on('click', function (e) {
                e.preventDefault();
                var activeIdTab = $(this).attr('data-href');
                $('.s-training-filter-ai__tabs-wrap').find('.s-training-filter-ai__tab').each(function () {
                    $(this).removeClass('active');
                    if ($(this).attr('data-href') == activeIdTab) {
                        $(this).addClass('active');
                    }
                })
                $('.s-training-filter-ai__content').find('.s-training-filter-ai__tab-result').each(function () {
                    $(this).removeClass('active');
                    if ($(this).attr('data-tab-id') == activeIdTab) {
                        $(this).addClass('active');
                    }
                })
            })

            $('.count-tickets__btn').on('click', function () {
                var numTickets = $(this).find('span').text();
                if ($(this).hasClass('count-tickets__btn_private')) {
                    $('.s-training-filter-ai__content').find('.s-training-filter-ai__tab').each(function () {
                        $(this).removeClass('active');
                        if ($(this).attr('data-href') == 'privateTrainingTab') {
                            $(this).addClass('active');
                        }
                    })
                    $('.s-training-filter-ai__content').find('.s-training-filter-ai__tab-result').each(function () {
                        $(this).removeClass('active');
                        if ($(this).attr('data-tab-id') == 'privateTrainingTab') {
                            $(this).addClass('active');
                        }
                    })
                    return;
                }
                $('.buttons-wrap_tickets-ai').find('.count-tickets__btn').each(function () {
                    $(this).removeClass('active');
                })
                $('.count-tickets__btn').each(function () {
                    if ($(this).find('span').text() == numTickets) {
                        $(this).addClass('active');
                    }
                })
            })

        }


        $('.from-to__input_private-ai-tickets').daterangepicker({
            startDate: moment().format('MM/DD/YYYY'),
            endDate: moment().add(3, 'd').format('MM/DD/YYYY')
        });
        $('.from-to__input_private-ai-tickets').on('change', function () {
            var dateRangArr = $(this).val().replace(/\s/g, '').split('-');
            $('.from-to__input_private-ai-tickets').each(function () {
                $(this).data('daterangepicker').setStartDate(dateRangArr[0]);
                $(this).data('daterangepicker').setEndDate(dateRangArr[1])
            })
        })
    }, 1300);
});


if (document.querySelector('#appTrainingFilter') !== null) {
    var app = new Vue({
        el: '#appTrainingFilter',
        data: {
            filters: {
                location: {
                    curProp: "",
                    list: []
                },
                date: {
                    curProp: "",
                    list: []
                },
                delegats: {
                    curProp: "5",
                    list: [
                        "5",
                        "6-10",
                        "11-15",
                        "16-20",
                        "21+"
                    ]
                }
            },
            tickets: [],
            trainingDescription: {},
            trainingDuration: {},
            apiUrl: 'https://api.tickets.altoros.com/api/v1',
            eventId: 1,
            eventName: '',
            eventPrice: 0,
            ticketId: 0,
            commonPrice: 0,
            commonPriceString: '0',
            privatePrice: 0,
            privatePriceString: '0',
            constPrivatePriceString: '0',
            privatePriceStringPerson: '0',
            ticketsNumber: 1,
            hideContent: true,
            popupIframeUrl: '',
            numberDelegats: '5',
            currentLocation: '',
            privateDateRange: '',
            bookingUrl: 'https://tickets.altoros.com/buy-ticket.html?token=',
            bookingToken: '',
            privateToken: '',
            checkDayTime: true,
            checkEvnTime: false,
            onlyPrivateTab: false,
            showSpecialPrice: false
        },
        mounted() {
        },
        components: {
        },
        watch: {

        },
        computed: {

        },
        created: function () {
            this.eventId = $('.s-training-filter_ai').attr('data-training-id');
            this.getData();
            if (navigator.platform == 'MacIntel' && !window.matchMedia('(hover: hover)').matches || navigator.platform == 'iPhone' && !window.matchMedia('(hover: hover)').matches) {
                $('.s-training-filter-ai__select').find('select').addClass('browser-default').wrap('<div class="select-wrap"></div>')
                $('.s-training-filter-ai__select').find('.select-dropdown').hide();
                $('.s-training-filter-ai__select').find('.caret').hide();
            }
            if (navigator.platform == 'Win32') {
                console.log("Win32")
            }

        },
        methods: {
            popupIframeOpenPopup: function(url){
                this.popupIframeUrl = url;
                $('#popup-frame').modal('open');
            },
            getData() {
                fetch(this.apiUrl + '/event/' + this.eventId, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then(res => res.json())
                    .then(response => {
                        console.log(response);
                        this.eventName = response.name;
                        this.tickets = response.tickets;
                        // this.commonPriceString = response.meta.default_cost;
                        this.privatePrice = response.meta.private_cost;
                        this.onlyPrivateTab = response.meta.private;
                        this.privatePriceString = this.formatNumber(this.privatePrice/2);
                        this.constPrivatePriceString = this.privatePrice;
                        this.privatePriceStringPerson = this.formatNumber(this.constPrivatePriceString / 10);
                        this.trainingDescription = response.meta.training_description;
                        this.trainingDuration = response.meta.training_duration;
                        let locations = [];
                        this.tickets.forEach( (el) => {
                            locations.push(el.location.name)
                        });
                        const SetLocations = new Set(locations);
                        this.filters.location.list = [...SetLocations];

                    })
                    .catch(error => {
                        console.error('Error:', error);
                        localStorage.removeItem('user');
                    });
            },
            bookData() {
                if(this.ticketId) {
                    let trainingTime;
                    if (this.checkDayTime) {
                        trainingTime = '9:00 AM - 4:00 PM'
                    } else if (this.checkEvnTime) {
                        trainingTime = '5:00 PM - 10:00 PM'
                    }
                    fetch(this.apiUrl + '/pre-payment/', {
                        method: 'POST',
                        body: JSON.stringify({
                            ticket_id: this.ticketId,
                            ticket_count: this.ticketsNumber,
                            event_id: this.eventId,
                            meta: {
                                time: trainingTime
                            }
                        }),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                        .then(res => res.json())
                        .then(response => {
                            this.bookingToken = response.token;
                            return (this.bookingUrl + this.bookingToken);
                        })
                        .then(url => {
                            this.popupIframeOpenPopup(url);
                        })
                        .catch(error => {
                            console.error('Error:', error);
                            localStorage.removeItem('user');
                        });
                }

            },
            priceCount() {
                this.commonPrice = this.ticketsNumber * this.eventPrice;
                this.commonPriceString = this.formatNumber(this.commonPrice);
            },
            changeTicketsNumber(number) {
                this.ticketsNumber = number;
                this.priceCount();
            },
            changeSelectDelegats(numberDelegats) {
                this.numberDelegats = numberDelegats;
                if (numberDelegats == '5') {
                    this.privatePriceString = this.formatNumber(this.constPrivatePriceString/2);
                    this.privatePriceStringPerson = this.formatNumber(this.constPrivatePriceString / 10);
                    this.showSpecialPrice = false;
                } else if (numberDelegats == '6-10') {
                    this.privatePriceString = this.formatNumber(this.constPrivatePriceString);
                    this.privatePriceStringPerson = this.formatNumber(this.constPrivatePriceString / 10);
                    this.showSpecialPrice = false;
                } else if (numberDelegats == '11-15') {
                    this.privatePriceString = this.formatNumber(Math.round(this.constPrivatePriceString * 1.1));
                    this.privatePriceStringPerson = this.formatNumber(Math.round(this.constPrivatePriceString * 1.1) / 15);
                    this.showSpecialPrice = false;
                } else if (numberDelegats == '16-20') {
                    this.privatePriceString = this.formatNumber(Math.round(this.constPrivatePriceString * 1.21));
                    this.privatePriceStringPerson = this.formatNumber(Math.round(this.constPrivatePriceString * 1.21) / 20);
                    this.showSpecialPrice = false;
                } else if (numberDelegats == '21+') {
                    this.showSpecialPrice = true;
                }


                let price_divided = this.privatePriceStringPerson.split(',');
                if(price_divided.length > 2) {
                    this.privatePriceStringPerson = price_divided.slice(0, 2).join();
                }

                setTimeout(()=> {
                    $('.vue-select__delegats').formSelect();
                }, 100);
            },
            changeSelectLocation(currentLocation) {
                this.currentLocation = currentLocation;
                let dateArr = [];
                this.tickets.forEach((el) => {
                    if (el.location.name == this.currentLocation) {
                        dateArr.push(el.start_date);
                    }
                });
                dateArr.sort((el1, el2) => {
                    let date1 = new Date(el1);
                    let date2 = new Date(el2);
                    return date1.getTime() - date2.getTime()
                });
                this.filters.date.list = dateArr;
                this.filters.date.curProp = dateArr[0];


                this.tickets.every( (el) => {
                    if (el.location.name == this.currentLocation && el.start_date == dateArr[0]) {
                        this.eventPrice = el.cost;
                        this.ticketId = el.id;
                        return false;
                    } else {
                        return true;
                    }
                });

                this.priceCount();
                setTimeout(()=> {
                    $('.vue-select__public-date').formSelect();
                    $('.vue-select__location').formSelect();
                    $('.location-block').each(function () {
                        $(this).find('input').css('color','#111111');
                    })
                }, 100);

            },
            changeSelectDate(currentDate) {
                this.tickets.every( (el) => {
                    if (el.location.name == this.currentLocation && el.start_date == currentDate) {
                        this.eventPrice = el.cost;
                        this.ticketId = el.id;
                        return false;
                    } else {
                        return true;
                    }
                });
                setTimeout(()=> {
                    $('.vue-select__public-date').formSelect();
                }, 100);
                this.priceCount();
            },
            formatNumber(num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            changeTimeDayCheckbox(event) {
                this.checkDayTime = true;
                this.checkEvnTime = false;
            },
            changeTimeEvnCheckbox(event) {
                this.checkDayTime = false;
                this.checkEvnTime = true;
            },
            goToPrivateForm(event) {
                event.preventDefault();
                this.privateDateRange = $('.from-to__input_private-ai-tickets').val().replace(/\s/g, '').split('-');
                let startPrivateDate = this.privateDateRange[0];
                let endPrivateDate = this.privateDateRange[1];


                fetch(this.apiUrl + '/pre-payment/', {
                    method: 'POST',
                    body: JSON.stringify({
                        ticket_id: 0,
                        ticket_count: 5,
                        event_id: this.eventId,
                        meta: {

                            numberDelegats: this.numberDelegats,
                            starteDate: startPrivateDate,
                            endDate: endPrivateDate,
                            eventId: this.eventId
                        }
                    }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then(res => res.json())
                    .then(response => {
                        this.privateToken = response.token;
                    })
                    .then(() => {
                        window.location.href = 'https://tickets.altoros.com/private-from-ticket.html?token=' + this.privateToken;
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        localStorage.removeItem('user');
                    });
            }
        }
    });
}
},{"cross-fetch":2}],2:[function(require,module,exports){
var __self__ = (function (root) {
function F() {
this.fetch = false;
this.DOMException = root.DOMException
}
F.prototype = root;
return new F();
})(typeof self !== 'undefined' ? self : this);
(function(self) {

var irrelevant = (function (exports) {
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = self.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  return exports;

}({}));
})(__self__);
delete __self__.fetch.polyfill
exports = __self__.fetch // To enable: import fetch from 'cross-fetch'
exports.default = __self__.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = __self__.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = __self__.Headers
exports.Request = __self__.Request
exports.Response = __self__.Response
module.exports = exports

},{}]},{},[1])